import { useEffect } from "react";

const SITE = "https://www.midstuning.co.uk";

/**
 * Set the <link rel="canonical"> to a specific path on the site.
 * Pass a path starting with "/" (e.g. "/blog/foo"). We normalise trailing slashes.
 * Pass null to remove the canonical entirely (use on 404/error pages).
 */
export function useCanonical(path) {
  useEffect(() => {
    const existing = document.querySelector('link[rel="canonical"]');
    if (path === null) {
      if (existing) existing.remove();
      return;
    }
    // Normalise: ensure single leading slash, no trailing slash except root
    let normalized = path || "/";
    if (!normalized.startsWith("/")) normalized = "/" + normalized;
    if (normalized.length > 1 && normalized.endsWith("/")) {
      normalized = normalized.replace(/\/+$/, "");
    }
    const href = `${SITE}${normalized}`;

    let tag = existing;
    if (!tag) {
      tag = document.createElement("link");
      tag.setAttribute("rel", "canonical");
      document.head.appendChild(tag);
    }
    tag.setAttribute("href", href);
    return () => {
      // Reset to site root on unmount so we never leave a stale canonical
      const t = document.querySelector('link[rel="canonical"]');
      if (t) t.setAttribute("href", `${SITE}/`);
    };
  }, [path]);
}
